import { call, fork, put, takeEvery } from 'redux-saga/effects';

import {
  fetchSTRCaseReportByCaseIdSuccess,
  fetchSTRCaseReportByCaseIdFail,
  FETCH_STR_CASE_REPORT_BY_CASE_ID,
  UPDATE_STR_CASE_REPORT_BY_CASE_ID,
  updateSTRCaseReportByCaseIdSuccess,
  updateSTRCaseReportByCaseIdFail,
  CREATE_STR_CASE_REPORT_BY_CASE_ID,
  createSTRCaseReportByCaseIdSuccess,
  createSTRCaseReportByCaseIdFail
} from '../../redux/actions/cm/caseReport';

import {
  createSTRCaseReportByCaseId,
  fetchSTRCaseReportByCaseId,
  updateSTRCaseReportByCaseId
} from '../../services/cm/cases';

function* fetchSTRCaseReportByCaseIdWorker(payload) {
  try {
    const caseReportDetails = yield call(fetchSTRCaseReportByCaseId, payload);

    yield put(fetchSTRCaseReportByCaseIdSuccess(caseReportDetails));
  } catch (error) {
    yield put(fetchSTRCaseReportByCaseIdFail(error.message));
  }
}

function* updateSTRCaseReportByCaseIdWorker(reportUpatedFields) {
  try {
    const res = yield call(updateSTRCaseReportByCaseId, reportUpatedFields);

    yield put(updateSTRCaseReportByCaseIdSuccess(res));
  } catch (error) {
    yield put(updateSTRCaseReportByCaseIdFail(error.message));
  }
}

function* createSTRCaseReportByCaseIdWorker({ caseId, alertIds }) {
  try {
    const caseReportDetails = yield call(createSTRCaseReportByCaseId, {
      caseId,
      alertIds
    });

    yield put(createSTRCaseReportByCaseIdSuccess(caseReportDetails));
  } catch (error) {
    yield put(createSTRCaseReportByCaseIdFail(error.message));
  }
}

export function* watchFetchSTRCaseReportByCaseId() {
  yield takeEvery(FETCH_STR_CASE_REPORT_BY_CASE_ID, function* ({ payload }) {
    yield fork(fetchSTRCaseReportByCaseIdWorker, payload);
  });
}

export function* watchUpdateSTRCaseReportByCaseId() {
  yield takeEvery(
    UPDATE_STR_CASE_REPORT_BY_CASE_ID,
    function* ({ payload: { reportUpatedFields } }) {
      yield fork(updateSTRCaseReportByCaseIdWorker, reportUpatedFields);
    }
  );
}

export function* watchCreateSTRCaseReportByCaseId() {
  yield takeEvery(
    CREATE_STR_CASE_REPORT_BY_CASE_ID,
    function* ({ payload: { caseId, alertIds } }) {
      yield fork(createSTRCaseReportByCaseIdWorker, { caseId, alertIds });
    }
  );
}
